import type {
  FeatureCollectionId,
  FeatureRef,
} from '@src/types/featureCollections.ts';
import {createAction} from '@reduxjs/toolkit';

const actionPrefix = 'FEATURE_COLLECTIONS';

export const selectCollectionFeatureRefs = createAction<FeatureRef[]>(
  `${actionPrefix}/SELECT_COLLECTION_FEATURE_REFS`,
);

export const setFeatureDetailsRef = createAction<FeatureRef | null>(
  `${actionPrefix}/SET_FEATURE_DETAILS_REF`,
);

export const setShowQuotaManagement = createAction<boolean>(
  `${actionPrefix}/SET_SHOW_QUOTA_MANAGEMENT`,
);

export const setVisibleCollection = createAction<FeatureCollectionId | null>(
  `${actionPrefix}/SET_VISIBLE_COLLECTION`,
);
